<template>
  <div class="match-header" :class="[timeLevelClass]" style="">
    <h1 class="title_league">
      <span @click="setSearch()">{{ league }}</span>
      {{ status === 2 ? `(Suspended)` : "" }}
      {{ permision === "isDev" ? id : "" }}
      <a
        v-if="permision === 'isDev'"
        :href="`/test_raise?id=${id}`"
        target="_blank"
        rel="noopener noreferrer"
        >Rise</a
      >
    </h1>
    <div class="favorite">
      <!-- A-9: favorite под правом *_FAVORITE, разворот (полные данные) под *_DATA -->
      <Lock :permission="favoriteKey">
        <span class="icon match-favorite view" @click="$emit('favorite')">
          <FavoriteStar :active="isFavorite" />
        </span>
      </Lock>
      <Lock :permission="dataKey">
        <span class="toggle-min icon view" @click="$emit('view')">
          <TriangleIcon :rotate="mini ? 'up' : 'down'" />
        </span>
      </Lock>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import FavoriteStar from "./FavoriteStar.vue";
import TriangleIcon from "./icons/Triangle.vue";
import Lock from "./Lock.vue";

// A-9: секция берётся из имени роута (live/prematch/ticker)
const route = useRoute();
const section = computed(() => String(route.name || "").toUpperCase());
const favoriteKey = computed(() => `${section.value}_FAVORITE`);
const dataKey = computed(() => `${section.value}_DATA`);

const props = defineProps({
  league: {
    type: String,
    default: "",
  },
  isFavorite: {
    type: Boolean,
    default: false,
  },
  timeLevelClass: {
    type: String,
    default: "",
  },
  mini: {
    type: Boolean,
    default: false,
  },
  id: {
    type: Number,
    default: 0,
  },
  permision: {
    type: String,
    default: "",
  },
  status: {
    type: Number,
    default: 0,
  },
});

const store = useStore();

function setSearch() {
  store.commit("SET_SEARCH_TEXT", props.league);
}
</script>

<style lang="scss" scoped>
.match-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 20px 40px 20px 40px;
  border-bottom: 1px solid var(--match-border-color);
  background-color: var(--league-body-color);
  color: var(--font-color);
  fill: var(--font-color);
}

.has-background-warning,
.has-background-success,
.has-background-danger {
  color: var(--back-color);
  fill: var(--back-color);
  stroke: var(--back-color);
}

.has-background-warning {
  background-color: var(--warning-background-opacity-medium) !important;
  border-bottom: none;
}

.has-background-success {
  background-color: var(--success-background-opacity-medium) !important;
  border-bottom: none;
}

.has-background-danger {
  background-color: var(--danger-background-opacity-medium) !important;
  border-bottom: none;
}

.title_league {
  font-size: 18px;
  font-weight: 700;
  line-height: 22.54px;
  color: inherit;
  text-decoration: underline;
  &:hover {
    color: var(--brand-color);
  }
}

.favorite {
  display: flex;
  align-items: center;
  gap: 20px;
}

.toggle-min {
  // стрелка 16x12 меньше звезды 24x24, поэтому её бокс добираем padding'ом:
  // по вертикали симметрично (стрелка не двигается, замок опускается на
  // половину), по горизонтали — как у звезды, чтобы замок ушёл вправо по
  // диагонали, а не строго вниз
  padding: 3px 5px;
  cursor: pointer;
  transition: fill 0.3s;
}

.arrow {
  rotate: 180deg;
  fill: var(--font-color);
}

@media screen and (max-width: 468px) {
  .match-header {
    padding: 10px;
  }
}
</style>
